import { useTranslation } from 'react-i18next';

import { Link } from 'Components';

import { ContentCopyIcon } from '@libs/shared/ui/icons';

type Props = {
  meetingLink: string | null | undefined;
  meetingPlatform: string | null | undefined;
};

export const MeetingLink = ({ meetingLink, meetingPlatform }: Readonly<Props>) => {
  const { t } = useTranslation();

  return meetingLink ? (
    <Link
      to={meetingLink}
      label={`${t('coursesPage.linkToOnlineMeeting')} (${meetingPlatform})`}
      leftIcon={<ContentCopyIcon />}
    />
  ) : (
    ''
  );
};
